import React from 'react';

const TechnologyDiagram = () => {
  return (
    <div className="bg-white p-8 rounded-xl shadow-md border border-gray-100">
      <div className="flex justify-center mb-8">
        <div className="relative w-full max-w-3xl">
          {/* Top Box - Raw Biosignal Input */}
          <div className="w-full bg-gray-200 rounded-md p-4 text-center mb-4">
            <div className="text-gray-700 font-medium">Raw Biosignal Input</div>
          </div>
          
          {/* Decomposer Network Box */}
          <div className="w-full bg-accent bg-opacity-20 rounded-md p-4 text-center mb-4 relative">
            {/* Connecting line from Raw Input to Decomposer */}
            <div className="absolute -top-4 left-1/2 h-4 w-0.5 bg-gray-400"></div>
            <div className="text-primary font-medium">Decomposer Network</div>
          </div>
          
          {/* Biomarker boxes with connecting lines */}
          <div className="flex justify-between mb-4 relative">
            {/* Connecting lines - vertical from decomposer to boxes */}
            <div className="absolute -top-4 left-[15%] h-4 w-0.5 bg-gray-400"></div>
            <div className="absolute -top-4 left-[50%] h-4 w-0.5 bg-gray-400"></div>
            <div className="absolute -top-4 left-[85%] h-4 w-0.5 bg-gray-400"></div>
            
            <div className="w-[30%] py-4 bg-primary text-white text-center font-medium rounded-md">
              Biomarker 1
            </div>
            <div className="w-[30%] py-4 bg-secondary text-white text-center font-medium rounded-md">
              Biomarker 2
            </div>
            <div className="w-[30%] py-4 bg-accent text-primary text-center font-medium rounded-md">
              Noise
            </div>
          </div>
          
          {/* Clinical Decision Making */}
          <div className="w-full bg-gray-200 rounded-md p-4 text-center relative">
            {/* Connecting lines - vertical from boxes to clinical decision */}
            <div className="absolute -top-4 left-[15%] h-4 w-0.5 bg-gray-400"></div>
            <div className="absolute -top-4 left-[50%] h-4 w-0.5 bg-gray-400"></div>
            <div className="absolute -top-4 left-[85%] h-4 w-0.5 bg-gray-400"></div>
            
            <div className="text-gray-700 font-medium">Clinical Decision Making</div>
          </div>
        </div>
      </div>
      
      <div className="text-center">
        <p className="text-gray-700 italic">
          "Our LBM has already demonstrated over 90% sensitivity in detecting respiratory disease flare-ups,
          proving the feasibility of AI-powered biosignal interpretation."
        </p>
      </div>
    </div>
  );
};

export default TechnologyDiagram;